import React, {Component, useState} from 'react';
import axios from 'axios';

import Paper from '@material-ui/core/Paper';
import {
    TreeDataState,
    CustomTreeData
} from '@devexpress/dx-react-grid';
import {
    Grid,
    VirtualTable,
    TableHeaderRow,
    TableTreeColumn
} from '@devexpress/dx-react-grid-material-ui';


import "./index.scss"
import swal from "sweetalert";
import data from "../../data";

export default class extends Component {

    handleOpen = async (e) => {
        e.preventDefault();
        const form = {
                "businessUnitID": 123,
                "type": "test",
                "competencyDate": "test",
                "typeDocument": "test"
            };

        axios.post(`http://domrockreportservice-env-1.eba-pdk3zhsf.us-east-1.elasticbeanstalk.com/v1/excel/report`, {form})
            .then(res => {
                console.log(res);
                console.log(res.data);
            })
    }

    render() {
        let {rows, headers, tableColumnExtensions, height} = this.props;

        const getChildRows = (row, rootRows) => (row ? row.items : rootRows);

        height = height ? height : 530;
        return (
            <>
                <Paper>
                    <Grid
                        rows={rows}
                        columns={headers}
                    >
                        <TreeDataState/>
                        <CustomTreeData
                            getChildRows={getChildRows}
                        />
                        <VirtualTable
                            height={height}
                            columnExtensions={tableColumnExtensions}
                        />
                        <TableHeaderRow/>
                        <TableTreeColumn
                            for="no-currents"
                        />
                    </Grid>
                </Paper>
            </>
        )
            ;
    }
}
